module.exports = __webpack_public_path__ + "static/img/logo.b1fa72ef.jpg";